import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

export type SelectedFilterPages =
  | 'alertEmailLogs'
  | 'alerts'
  | 'business'
  | 'businessUnits'
  | 'carriers'
  | 'clients'
  | 'clientTypes'
  | 'companies'
  | 'documentCategory'
  | 'groups'
  | 'palletTypes'
  | 'permissions'
  | 'products'
  | 'productTypes'
  | 'suppliers'
  | 'transitTimeAr'
  | 'users'
  | 'vehicles'
  | 'vehicleTypes'
  | 'valePedagioTaxas'
  | 'zipcodeInternacionals'
  | 'none';

const { Types, Creators } = createActions(
  {
    success: ['data'],
    reset: [],
  },
  { prefix: 'SELECTED_FILTER_' }
);

export interface SelectedFilterState {
  data: Record<SelectedFilterPages, any>;
}

interface SuccessSelectedFilter {
  data: Record<SelectedFilterPages, any>;
}

const INITIAL_STATE: SelectedFilterState = {
  data: {} as Record<SelectedFilterPages, any>,
};

const success = (state: SelectedFilterState, action: SuccessSelectedFilter) =>
  update(state, {
    data: { $set: action.data },
  });

const reset = () => INITIAL_STATE;

export const selectedFilter = createReducer(INITIAL_STATE, {
  [Types.SUCCESS]: success,
  [Types.RESET]: reset,
});

export const SelectedFilterTypes = Types;
export const SelectedFilterActions = Creators;
